<template>
    <AdminBar title_action="Edit product" :url_action="url_edit_produt" :url_admin = "url_admin" />
    <div id="main single-product__main" class="main_single_product" v-if="singleProduct" :key="_productID">
        <PasswordProtectedForm v-if="passwordProtected && !isPasswordSuccess" :data="_productID" @handlePasswordProtect="handlePasswordProtect" />
        <div v-if="!passwordProtected || isPasswordSuccess">
            <WooNotice />
            <div class="pc_woocommerce_breadcrumb" style="display: none;">
                <Breadcrumb v-if="breadCrumb" :data="breadCrumb" :name="productData.post_title"/>
                <HeadingExtra :data="sku" />
            </div>
            <div id="product">
                <div :class="[
                    'main_product',
                    { 'main_product--customise': isCustomise }
                ]">
                    <ProductTag v-if="productTag" 
                    :data="productTag"
                        :classCustomise="isCustomise ? 'customise_tag_detail' : ''" />
                    <template v-if="!isCustomise">
                        <GalleryLoad v-if="!productGallery && !passwordProtected"/>
                        <Gallery v-else-if="productGallery && !isCustomise" :data="productGallery" :isPre0rder="isPre0rder" :maxHeight="maxHeight" :material="productMaterial" :name="productData?.post_title" />
                    </template>
                    <template v-else >
                        <GalleryLoad v-if="maxHeight === 0"/>
                        <GalleryCustomise 
                         v-else-if="productGalleryCustomise "
                            :data="productGalleryCustomise"
                            :galleryItems="galleryItems"
                            :variation="productVariationCustomise"
                            :productGallery = "productGallery"
                            :thumb="thumbnail360"
                            :maxHeight="maxHeight"
                            :isPre0rder="isPre0rder"
                            :material="productMaterial"
                            :name="productData?.post_title"
                        />
                    </template>


                    <div class="summary entry-summary" :class="{ isLabourProduct: labourData.isLabourProduct }" >
                        <Breadcrumb v-if="breadCrumb" :data="breadCrumb" :name="productData.post_title" />
                        <header class="heading_product">
                            <h1 v-if="productData && productData.post_title && productTitle" class="entry-title">{{ htmlSpecialcharsDecode(productTitle) }}</h1>
                            <HeadingExtra :data="sku" />
                        </header>
                        <!-- isCustomise ? priceDataCustomise : priceData -->

                        <Price v-if="priceData && priceData.price && !productData.isRequestPrice" 
                        :priceInfo="isCustomise ? priceDataCustomise : priceData" 
                        :shortTermData= priceData?.short_term_data 
                        :labourData="labourData" 
                        :priceTeaser="priceTeaser" />

                        <OapsRibbon v-if="gwpEligible" :data="gwpEligible"/>

                        <SizeGuide v-if="productData && productData.sizeGuide" :data="productData.sizeGuide"/>
                        <AddToCartForm
                            v-if="productData"
                            :isCustomise="isCustomise"
                            :lorem="isCustomise"
                            :engravingCustomise="engravingCustomise"
                            :materialPriceData="materialPriceData" 
                            :saleDate="saleDate"
                            :materialMultiplierData="materialMultiplierData"
                            :customiseNameNecklace="customiseNameNecklace"
                            :multiCustomiseNameNecklace="multiCustomiseNameNecklace"
                            :titleAtributeP="titleAtribute"
                            :charsWeight="charsWeight"
                            :breadCrumbChild = "isPixiuBracelet"
                            :customiseBackNameNecklace="customiseBackNameNecklace"
                            :customiseFontVisualNameNecklace="customiseFontVisualNameNecklace"
                            :thumbnailStickyBarCustomise="isCustomise ? thumbnailStickyBarCustomise : ''"
                            :slug="slug"
                            :idsFirstActive="isCustomise ? firstAttributeActiveIds : ''"
                            :isPre0rder="isPre0rder"
                            :isButtonActive="isButtonActive"
                            :freeChainOptionData="freeChainOptionData"
                            :freeBraceletData="freeBraceletData"
                            :chainOptionData="chainOptionData"
                            :engravingData="engravingData"
                            :engravingDesignStatus = "engravingDesignStatus"
                            :bundleData="bundleData"
                            :priceInfo="isCustomise ? priceDataCustomise : priceData"
                            :priceInfoInit="isCustomise ? priceDataCustomise : priceData"
                            :product="productData"
                            :actButton="actButton"
                            :productType="productType"
                            :variableData="isCustomise ? variableDataCustomise : variableData"
                            :shippingDate="shippingDate"
                            :gtmItem="gtmProps"
                            :initialSku="initialSku" 
                            :enableErp="enableErp" 
                            :isCheckChina = "isCheckChina"
                            @updatePrice="updatePriceInfo"
                            @updatePriceCustomise="updatePriceInfoCustomise"
                            @update-selection="handleSelectionUpdate"
                            @update-preorder="handlePreOderUpdate"
                            @update-gallery-image="updateGalleryImage"
                            @update-thumbnail-image="updateThumbnailImage"
                            @update-sku="updateSku"
                            @update-oos="updateOOS"
                            @variant-changed="handleVariantChange"
                        />

                        <OutOfStockNotification :related="relatedProducts" :pid="productData.ID" v-if="isOutOfStock" />

                        <div class="promotion_banner" v-if="img_promotion_banner_dsk || img_promotion_banner_mb">
                            <NuxtLink :to="link_promotionBanner">
                                <img class="custom_banner_dsk alt-lazy-img" :data-original_src="`${baseUrl}api/wp-content/uploads/${img_promotion_banner_dsk}`" :src="`${baseUrl}api/wp-content/uploads/${img_promotion_banner_dsk_lazy}`" :alt="img_promotion_banner_dsk_alt">
                                <img class="custom_banner_mb alt-lazy-img" :data-original_src="`${baseUrl}api/wp-content/uploads/${img_promotion_banner_mb}`" :src="`${baseUrl}api/wp-content/uploads/${img_promotion_banner_mb_lazy}`" :alt="img_promotion_banner_mb_alt">
                            </NuxtLink>
                        </div>
                        <CartBottom v-if="productDescription" 
                        :data="productDescription" 
                        :isCustomise="isCustomise"
                        :priceInfo="isCustomise ? priceDataCustomise : priceData" 
                        :paymentPlan="paymentPlanData"
                        :date_delivery="dateDelivery"
                        :date_collection="dateCollection"
                         />
                    </div>
                </div>

                <ShippingDes :isCustomise="isCustomise" :dataShippingDesc="dataShippingDesc" />
                <Faqs v-if="isCustomise && data_faq && data_faq.faqs_items.length > 0" :data="data_faq" :option_faqs="option_faqs" />

                <GetTheLook v-if="getTheLook" :data="getTheLook" />
                <Faqs v-if="!isCustomise && data_faq && data_faq.faqs_items.length > 0" :data="data_faq" :option_faqs="option_faqs" />
                <MasterTemplate 
                isPage="single-product" 
                v-if="itemInformation" 
                :data="itemInformation"
                :productID="_productID"
                />

                <Review v-if="reviewData" :data="reviewData" @handle-aggregate-rating="handleAggregateRating"/>
                <Premium v-if="premieumData" :data="premieumData" />

                <template v-if="isCheckResponInsider && (dataInsiderRecommend?.products?.length || dataInsiderRelated?.products?.length)">
                    <UnboxCarouselInsider :recommendation="dataInsiderRecommend" :related="dataInsiderRelated" />
                </template>

                <AlsoRecently v-if="recentlyProducts" :data="recentlyProducts" />

                <MediaFeed v-if="mediaFeed" :data="mediaFeed" />
                <CollectionCategory v-if="collectionCategoryProducts" :data="collectionCategoryProducts" />

                <SliderBottomCategory v-if="dataSliderBottom && Object.keys(dataSliderBottom).length > 0" :data="dataSliderBottom" />

            </div>
        </div>
    </div>
</template>

<style lang="scss">
    // Critical CSS for Desktop
    @media (min-width: 768px) {
       .box_gallerry {
            position: relative;
            width: 50%;
        }
        .main_product .entry-summary {
            margin-left: 2%;
            width: 48%;
        }
        .woocommerce-breadcrumb {
            color: #9d9d9d;
            font-size: .92em;
            font-weight: 400;
            margin-bottom: 25px;
        } 
        .woocommerce-breadcrumb a {
            color: #9d9d9d;
        }
        .main_product .entry-summary .heading_product {
            display: flex;
            margin-bottom: 20px;
        }
        .main_product .entry-summary .heading_product .entry-title {
            color: #212529;
            font-size: 32px;
            font-weight: 700;
            margin-bottom: 0;
            margin-top: 0;
            text-transform: capitalize;
        }
        .heading_product_extra {
            align-items: center;
            -moz-column-gap: 30px;
            column-gap: 30px;
            display: flex;
            margin-left: auto;
        }
        .heading_product_extra .heading_product__icon {
            cursor: pointer;
            padding: 5px 0;
            position: relative;
        }
        .heading_product_extra .heading_product__icon>img {
            width: 15px;
        }
        .heading_product_extra .heading_product__icon .heading_product__sku-modal {
            display: none;
        }
        .heading_product_extra .heading_product__icon .heading_product__share-popup {
            align-items: center;
            background-color: #fff;
            border: 1px solid #e8e8e8;
            border-radius: 5px;
            box-shadow: 12px 30px 34px #0003;
            -webkit-box-shadow: 12px 30px 34px 0 rgba(0, 0, 0, .2);
            -moz-box-shadow: 12px 30px 34px 0 rgba(0,0,0,.2);
            -moz-column-gap: 10px;
            column-gap: 10px;
            cursor: pointer;
            display: none;
            flex-direction: row;
            justify-content: center;
            padding: 10px 10px 6px;
            position: absolute;
            right: -20px;
            top: 35px;
            width: 200px;
            z-index: 2006;
        }
        .size-guide__popup {
            background-color: #00000080;
            bottom: 0;
            left: 0;
            opacity: 0;
            position: fixed;
            right: 0;
            top: 0;
            transform: none;
            transition: all .3s ease-in-out;
            visibility: hidden;
            width: 100%;
            z-index: 9999;
        }
        .single-product__shipping {
            background: #c60c46;
            margin-bottom: 40px;
        }
        .single-product__shipping .single-product__shipping-item {
            align-items: center;
            color: #fff;
            display: flex;
            justify-content: space-evenly;
            list-style: none;
            padding: 0 15px;
            gap: 12px;
        }

        .single-product__shipping .single-product__shipping-item li {
            font-size: 16px;
            font-weight: 300;
            padding: 15px;
            text-align: center;
            text-transform: uppercase;
           
             flex: 1 1 200px; 
              display: flex;
              align-items: center;      
              justify-content: center;  
              gap: 8px;                 
              text-align: center;
        }
        .single-product__shipping .single-product__shipping-item li:first-child {
            padding-left: 5px;
        }
        .single-product__shipping .single-product__shipping-item img {
            display: inline-block;
            margin-right: 10px;
            max-height: 50px;
            max-width: 50px;
            vertical-align: middle;
        }
        .single-product__shipping .single-product__shipping-item .single-product__shipping-item-description {
            display: inline-block;
            min-width: 157px;
            text-align: left;
            vertical-align: middle;
        }
    }
    @media (max-width: 1190px) {
         .single-product__shipping .single-product__shipping-item li {
            flex-flow: column;
         }
        .single-product__shipping .single-product__shipping-item .single-product__shipping-item-description {
            text-align: center;
        }
    }
    @media (max-width: 767px) {
        .main_product {
            flex-wrap: wrap;
            padding: 0;
            margin-top: 0;
        }
        .box_gallerry {
            width: 100%;
        }
        .box_gallerry .woocommerce-product-gallery.splide:not(.is-initialized){
            /* display: none; */
        }
        .main_product .entry-summary {
            width: 100%;
            margin-left: 0;
        }
        .heading_product_extra {
            width: 20%;
            -moz-column-gap: 20px;
            column-gap: 20px;
        }
        .heading_product_extra .heading_product__icon {
            cursor: pointer;
            padding: 5px 0;
            position: relative;
        }
        .heading_product_extra .heading_product__icon>img {
            width: 15px;
        }
        .heading_product_extra .heading_product__icon .heading_product__sku-modal {
            display: none;
        }
        .heading_product_extra .heading_product__icon .heading_product__share-popup {
            align-items: center;
            background-color: #fff;
            border: 1px solid #e8e8e8;
            border-radius: 5px;
            box-shadow: 12px 30px 34px #0003;
            -webkit-box-shadow: 12px 30px 34px 0 rgba(0, 0, 0, .2);
            -moz-box-shadow: 12px 30px 34px 0 rgba(0,0,0,.2);
            -moz-column-gap: 10px;
            column-gap: 10px;
            cursor: pointer;
            display: none;
            flex-direction: row;
            justify-content: center;
            padding: 10px 10px 6px;
            position: absolute;
            right: -20px;
            top: 35px;
            width: 200px;
            z-index: 2006;
        }
        .size-guide__popup {
            background-color: #00000080;
            bottom: 0;
            left: 0;
            opacity: 0;
            position: fixed;
            right: 0;
            top: 0;
            transform: none;
            transition: all .3s ease-in-out;
            visibility: hidden;
            width: 100%;
            z-index: 9999;
        }
        .single-product__shipping {
            background: #c60c46;
            margin-bottom: 40px;
            margin-left: -15px;
            margin-right: -15px;
        }
        .single-product__shipping .single-product__shipping-item {
            align-items: center;
            color: #fff;
            display: flex;
            justify-content: space-evenly;
            list-style: none;
            padding: 0 15px;
            align-items: flex-start;
        }

        .single-product__shipping .single-product__shipping-item li {
            text-transform: uppercase;
            align-items: anchor-center;
            justify-content: flex-start;
            text-align: left;
            font-size: 14px;
            padding: 10px 5px;
            max-width: 50%;
            width: 50%;
            display: flex;
            flex-direction: row;
        }
        
        .single-product__shipping .single-product__shipping-item img {
            max-height: 100px;
            display: block;
            min-width: 35px;
            height: auto;
            margin: 0;
            vertical-align: middle;
            max-width: 50px;
        }
        .single-product__shipping .single-product__shipping-item .single-product__shipping-item-description {
            text-align: left;
            width: calc(100% - 70px);
            min-width: auto;
            display: inline-block;
            vertical-align: middle;
        }
    }
    @import "@/assets/scss/components/product/_product.scss";
</style>

<script setup lang="ts">
    import { ref, onMounted, computed } from 'vue';
    import { useRoute } from 'vue-router';
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const route = useRoute();
    const router = useRouter();
    const slug = computed(() => route.params.slug as string);
    const { $ajax } = useNuxtApp();
    const isOutOfStock = ref(false);
    import WooNotice from "~/components/Product/SingleProduct/WooNotice.vue";
    import AdminBar from "~/components/Product/AdminBar.vue";
    import {useSingleMeta} from "~/composables/useMeta";
    import { calculatorPriceCustomise2, calculatorPriceCustomiseMultiNameNecklace } from "~/utils/getPriceDataCustomise";


    import { useInsiderSearchTracking } from '@/composables/insiderSearch'
    const { getUUidInsiderSearch,trackInsiderSearchEvent, sendInsiderEvent, getSingaporeRFC3339 } = useInsiderSearchTracking()

    const promotion_banner = ref();
    const img_promotion_banner_dsk = ref('');
    const img_promotion_banner_dsk_lazy = ref('');
    const img_promotion_banner_dsk_alt = ref('');
    const img_promotion_banner_mb = ref('');
    const img_promotion_banner_mb_lazy = ref('');
    const img_promotion_banner_mb_alt = ref('');
    const link_promotionBanner = ref('');
    interface IWooNotice {
        message: String[],
        type: String,
    }
    const isNotice = ref(true);
    const wooNotice = ref<IWooNotice>({
        message: [],
        type: ''
    });


    import OutOfStockNotification from '~/components/Product/OutOfStockNotification';
    import PasswordProtectedForm from '~/components/PasswordProtectedForm.vue';
    import Breadcrumb from "~/components/Product/SingleProduct/Layouts/Breadcrumb.vue"
    import AddToCartForm from '~/components/Product/SingleProduct/AddToCartForm.vue';
    import HeadingExtra from "~/components/Product/SingleProduct/Layouts/HeadingExtra.vue"
    import ShippingDes from "~/components/Product/SingleProduct/ShippingDes.vue"
    import GetTheLook from "~/components/Product/SingleProduct/GetTheLook.vue"
    import Premium from "~/components/Product/SingleProduct/Premium.vue"
    import Review from "~/components/Product/SingleProduct/Review.vue"
    import Faqs from "~/components/Product/SingleProduct/Faqs.vue"
    // import Information from "~/components/Product/SingleProduct/Information.vue"
    import UnboxCarouselLoad from "~/components/Product/SingleProduct/UnboxCarouselLoad.vue"
    import UnboxCarousel from "~/components/Product/SingleProduct/UnboxCarousel.vue"
    import AlsoRecently from "~/components/Product/SingleProduct/AlsoRecently.vue"
    import Usp from "~/components/Product/SingleProduct/Usp.vue"
    import MediaFeed from "~/components/Product/SingleProduct/MediaFeed.vue"
    import CollectionCategory from "~/components/Product/SingleProduct/CollectionCategory.vue";
    import Gallery from "~/components/Product/SingleProduct/Layouts/Gallery.vue";
    import GalleryLoad from "~/components/Product/SingleProduct/Layouts/GalleryLoad.vue";
    import GalleryCustomise from "~/components/Product/SingleProduct/Layouts/GalleryCustomise.vue";
    import ButtonCart from "~/components/Product/SingleProduct/Layouts/ButtonCart.vue";
    import CartBottom from "~/components/Product/SingleProduct/Layouts/CartBottom.vue";
    import OapsRibbon from "~/components/Product/SingleProduct/Layouts/OapsRibbon.vue";
    import SizeGuide from "~/components/Product/SingleProduct/Layouts/SizeGuide.vue";
    import BraceletSimple from "~/components/Product/SingleProduct/Layouts/FreeBracelet.vue";
    import Price from "~/components/Product/SingleProduct/Layouts/Price.vue";
    import MasterTemplate from "~/components/TemplateMaster/MasterTemplate.vue";
    import ProductTag from "~/components/Product/SingleProduct/ProductTag.vue";
    import SliderBottomCategory from "~/components/Product/SingleProduct/SliderBottomCategory.vue";
    import UnboxCarouselInsider from "~/components/Product/SingleProduct/UnboxCarouselInsider.vue"
    import { displayCustomPrice, displayPrice } from "~/utils/displayPrice";
    import { lexerTracking } from '~/assist/SingleProduct';
    import { useCustomGtm } from '~/composables/useEventTagManager';
    import { useInsiderSdk } from '~/composables/insiderSdk';
    import moment from "moment";
    import { convertPriceDecimal } from '@/utils/formatPrice';
    interface TitleAttribute {
  [attributeSlug: string]: {
    [attributeId: string]: string;
  };
}
    const firstVariation = ref({});
    const collectionCategoryProducts = ref();
    const {
        trackCustom, singleViewItemListEventTracking, pushToDataLayer, pushPageTypeToDataLayer
    } = useCustomGtm();
    const gtm = useGtm()
    const wooStore = useWooStore();
    const maxHeight = ref(0);
    const getTheLook = ref();
    const productData = ref();
    const breadCrumb = ref();
    const sku = ref();
    const initialSku =ref();
    const uspSection = ref();
    const mediaFeed = ref();
    const premieumData = ref();
    const data_faq = ref();
    const productGallery: Ref<GalleryItem[]> = ref([]);
    const productDescription = ref();
    const reviewData = ref({});
    const isGoldWeight = ref(true);
    const isFreeBracelet = ref(false);
    const isChainOption = ref(false);
    const priceData = ref();
    const priceTeaser = ref<{text: string, price: string}>();
    const thumbnailStickyBar = ref();
    const actButton = ref()
    const variableData = ref()
    const shippingDate = ref()
    const initialImage = ref()
    const productTag = ref();
    const productType = ref();
    const productTitle = ref<string>('');
    const productMaterial = computed(() => productData.value?.TermRelationship?.find((item: any) => item.termTaxonomy?.taxonomy === "material")?.termTaxonomy?.term?.name);
    const passwordProtected = ref<boolean>(true);
    const idItemProduct = ref();
    const url_edit_produt = ref('');
    const url_admin = ref('');

    const productDataCustomise = ref();
    const thumbnail360 = ref('');
    const productGalleryCustomise: Ref<GalleryItem[]> = ref([]);
    const productVariationCustomise: Ref<GalleryItem[]> = ref([]);
    const productGalleryProduct: Ref<GalleryItem[]> = ref([]);
    const firstAttributeActiveIds = ref('');
    const priceCustomise = ref<any>({});
    const shortTermData = ref<any>({});
    const priceDataCustomise = ref<PriceData>({ regular_price: '' });
    const engravingCustomise = ref('no');
    const customiseEngravingFee = ref('15')
    const isCustomise = ref(false);
    const variableDataCustomise = ref();
    const thumbnailStickyBarCustomise = ref();
    type MaterialPrice = Record<string, string>;
    const engravingDesignStatus = ref('instock');

    const materialPriceData = ref<MaterialPrice>({});
    const saleDate = ref({});
    const materialMultiplierData = ref<Record<string, number>>({});
    const gtmProps = ref();
    const customiseNameNecklace: Ref<CustomiseNameNecklace[]> = ref([]);
    const multiCustomiseNameNecklace: Ref<CustomiseNameNecklace[]> = ref([])
    const titleAtribute: Ref<TitleAttribute> = ref({});
    const charsWeight = ref({});
    
    const customiseBackNameNecklace: Ref<CustomiseNameNecklace[]> = ref([]);
    const customiseFontVisualNameNecklace: Ref<CustomiseNameNecklace[]> = ref([]);
    const paymentPlanData = ref<any>({});
    const dateDelivery = ref<any>({});
    const dateCollection = ref<any>({});
    const dataSliderBottom = ref({});
    const productDataInsiderSdk = ref({});
    const skuData = ref({});
    const currency = 'MYR';
    const enableErp = ref('0');
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    let country = '';
    if (locale.value === 'ms-my') {
        country = '/ms-my';
    } else {
        country = '';
    }
    interface IGWPEligible {
        rule_title: string;
        product_data: {
            name: string,
            price: string
            thumbnail: string,
        }
    }
    const isCheckChina = ref('no');

    const gwpEligible = ref<IGWPEligible[]>();


    interface CustomiseNameNecklace {
      status: string,
      afterAttribute: string
    }

    interface TermRelationship {
        termTaxonomy: {
            taxonomy: string;
            term: {
            slug: string;
            };
        };
        }

    interface freeBraceletData{
        isFreeBracelet: boolean
        freeBracelet: object[]
        defaultBracelet: string,
        freeBraceletsStock: object[],

    }
    const freeBraceletData = ref<freeBraceletData>();

    interface chainOptionData{
        isChainOption: boolean
        chainProduct: object[]
        titleChainOption: string
    }
    const chainOptionData = ref<chainOptionData>();
    const freeChainOptionData = ref<chainOptionData>();

    interface labourData{
        isLabourProduct: boolean
        goldWeightData: object[]
    }
    const engravingData = ref<engravingData>();

    interface engravingData{
        isEngraving: boolean
        engravingDataProduct: object[]
    }
    const bundleData = ref<bundleData>();
    interface bundleData{
        isBundle: boolean
        bundleDataProduct: object[]
    }

    const labourData = ref<labourData>();

    interface ProductResponse {
        success: boolean;
        data: {
            post_status: string;
            breadcrumb: string[];
            sku: any;
            uspData: any;
            mediaFeed: any[];
            premierData: any;
            faq: any[];
            getTheLook: any;
            productGallery: any[];
            enableErp: string;
            productDescription: any[];
            revirew: any[];
            priceData: any[];
            promotionBanner: any[];
            listItemBottomSingle: any[];
            getDataCategoryCollection: any;
        };
        excluded: boolean;
    }
    interface GalleryItem {
        id: string;
        type: string;
        position: string;
        thumbnail: string;
        woocommerce_single: string;
        zoomsrc: string;
    }
    interface ResponseAPI {
        success: boolean;
        data: any;
        message: string
    }

    const aggregateRatingValue = ref<any>({});
    const reviewDatas = ref<any[]>([]);
    const handleAggregateRating = (reviewSchema: any) => {
        aggregateRatingValue.value = reviewSchema.aggregateRating;
        reviewDatas.value = reviewSchema.reviewData;;
    };

    const isPixiuBracelet = ref(false);

    const lexerTrackingData = ref<{eventName: string, eventValue: string}[]>([]);

    const _productID = ref();
    const singleProduct = ref<ProductResponse | null>(null);
    const schema = ref({});
    const breadcrumbSchema = ref({});
    const termData = ref({});
    const userStore = useUserStore();
    const dataShippingDesc = ref();

    const updateOOS = (value: boolean) => {
        isOutOfStock.value = value;
    }

    watch(() => wooStore.singleProduct.status, (newValue, oldValue) => {
        isOutOfStock.value = newValue === 'outofstock' ? true : false;
    }, { deep: true })

const setDataLayer = async (productId: number) => {
    try {
        const response = await $ajax.get<{success: boolean; data: any}>(`wp-json/skj/v1/datalayer/single/${productId}`);
        if (response.success && gtm ) {
            trackCustom(response.data);
        }
    } catch (error) {
        console.error('Failed to load user tracking data:', error)
    }
}

type TermTaxonomy = {
  term_id: string
  parent: string
  taxonomy: string
  term: {
    name: string
  }
}

type TermRelationshipItem = {
  termTaxonomy: TermTaxonomy
}

function buildCategorySchemaPush(
  termRelationships: any[],
  categorySchema: string[]
): string[] {
  const result: string[] = []
  const basePath = 'Apparel & Accessories > Jewelry'


  const productCats = termRelationships
    .filter(tr => tr.termTaxonomy?.taxonomy === 'product_cat')
    .map(tr => tr.termTaxonomy)

  // Map term_id => category
  const catMap: Record<string, any> = {}
  productCats.forEach(cat => {
    catMap[cat.term_id] = cat
  })

  
  const parentIds = new Set(productCats.map(cat => cat.parent))
  const leafCategories = productCats.filter(
    cat => !parentIds.has(cat.term_id)
  )

  const findSchemaCategory = (cat: any): string | null => {
    let current = cat

    while (current && current.parent !== '0') {
   
      const name = htmlSpecialcharsDecode(current.term.name)
        
      if (categorySchema.includes(name)) {
        return name
      }

      current = catMap[current.parent]
    }

    
    if (current) {
      let rootName = htmlSpecialcharsDecode(current.term.name)
      //console.log('------ current',rootName,current.term.name);
      if (rootName === 'Pendant and Necklaces') {
        rootName = 'Necklaces';
      }
       if (rootName === 'Charms') {
        rootName = 'Charms & Pendants';
      }
      if (categorySchema.includes(rootName)) {
        return rootName
      }
    }

    return null
  }



let hasSchemaCat = false;

for (const cat of leafCategories) {
  const schemaCat = findSchemaCategory(cat);

  if (schemaCat) {
    const path = `${basePath} > ${schemaCat}`;

    if (!result.includes(path)) {
      result.push(path);
      hasSchemaCat = true;
      break; 
    }
  }
}


if (!hasSchemaCat && !result.includes(basePath)) {
  result.push(basePath);
}


  return result
}

    const { data: asyncSingleProduct } = await useAsyncData<ProductResponse>(
        () => `singleProduct-${route.params.slug}`,
        async () => {
            return $ajax.get(`${runtimeConfig.public.API_URL}product/${route.params.slug}`, {
                headers: {
                'X-API-Key': userStore.csrf,
                'X-API-Server': userStore.csrf_server
                }
            });
        },
        {
            watch: [() => route.params.slug]
        }
    );

    const getProductData = async () => {
        try {
            const data = asyncSingleProduct;

            if (data.value) {
                if( ! data.value.success && typeof data.value.url !== 'undefined' ) {
                    router.push(`${country}/shop/`);
                    return;
                }
                url_admin.value = runtimeConfig.public.BASE_URL + 'api/wp-admin/';
                if(data.value.data){
                    skuData.value = data.value.data.PostMeta.find(meta => meta.meta_key === '_sku');
                    enableErp.value = data.value.data.PostMeta.find(
                meta => meta.meta_key === 'enable_sys_to_erp'
                )?.meta_value;
                    console.log('--- enableErp: ',enableErp.value)
                    idItemProduct.value =  data.value.data.ID;
                    dataSliderBottom.value = data.value.data?.listItemBottomSingle;
                    url_edit_produt.value = runtimeConfig.public.BASE_URL + 'api/wp-admin/post.php?post=' + idItemProduct.value + '&action=edit';
                    promotion_banner.value = data.value.data?.promotionBanner
                    img_promotion_banner_dsk.value = promotion_banner.value?.desktop_img ?? '';
                    img_promotion_banner_dsk_lazy.value = promotion_banner.value?.desktop_img_lazy ?? '';
                    img_promotion_banner_dsk_alt.value = promotion_banner.value?.desktop_img_alt ?? '';
                    img_promotion_banner_mb.value = promotion_banner.value?.mobile_img ?? '';
                    img_promotion_banner_mb_lazy.value = promotion_banner.value?.mobile_img_lazy ?? '';
                    img_promotion_banner_mb_alt.value = promotion_banner.value?.mobile_img_alt ?? '';
                    link_promotionBanner.value = promotion_banner.value?.link ?? '';
                    dataShippingDesc.value = data.value.data?.shippingDes || null;
                }
                // Redirect to Shop
                if (data.value.excluded){
                    router.push(`${country}/shop/`);
                    return;
                }
                // Check Private
                const postStatus = data.value.data.post_status ?? null;
                if (postStatus === 'private'){
                    if (!userStore || !userStore.isLogin || !userStore.user || !userStore.user.role || userStore.user.role !== 'administrator'){
                        router.push(`${country}/404/`);
                        return;
                    }
                }

                // End Private
                singleProduct.value = data.value;
                productData.value = data.value.data;
                isCustomise.value = productData.value.isCustomise;
                collectionCategoryProducts.value = productData.value?.getDataCategoryCollection;


                if (isCustomise.value) {


                    productDataCustomise.value = data.value.data;

                    engravingCustomise.value = productData.value?.customiseEngravingSettings;

                    productGalleryProduct.value = productData.value.gallery.filter(item => item.type !== 'video');
                    const galleryItems = Object.values(
                        productData.value.firstVariationProduct?.media?.gallery_items || {}
                        ) as GalleryItem[];

                        productGalleryCustomise.value = [
                        ...galleryItems,
                        ...productGalleryProduct.value
                        ];


                    productVariationCustomise.value = Object.values(productData.value.firstVariationProduct?.media?.gallery_items || {});

                    customiseNameNecklace.value =  productData.value.customiseNameNecklace || {};
                     multiCustomiseNameNecklace.value = productData.value.customiseMultiNameNecklace || {};
                    customiseBackNameNecklace.value = productData.value.customiseBackNameNecklace || {};
                customiseFontVisualNameNecklace.value = productData.value.customiseFontVisualNameNecklace || {};
                charsWeight.value = productData.value.charactersWeight || {};
                 titleAtribute.value = productData.value.titleAtribute || {};
                //    const thum360 = productData.value.firstVariationProduct?.thumbnail360;

                //     if (thum360) {
                //         thumbnail360.value = thum360;
                //     } else {
                //         const videoProduct = productData.value.gallery.find(item => item.type === 'video');
                //         thumbnail360.value = videoProduct?.woocommerce_single
                //         ? baseUrl + 'api/wp-content/uploads/' + videoProduct.woocommerce_single
                //         : '';
                //     }


                    if (productData.value.customiseFontChineseActive) {
                        isCheckChina.value = productData.value.customiseFontChineseActive?.status || 'no';
                    }
                    const videoProduct = productData.value.gallery.find(item => item.type === 'video');
                        thumbnail360.value = videoProduct?.woocommerce_single
                        ? baseUrl + 'api/wp-content/uploads/' + videoProduct.woocommerce_single
                        : '';
                   
                    thumbnailStickyBarCustomise.value = productData.value.firstVariationProduct?.thumbnail || '';
                    priceCustomise.value = productData.value.firstVariationProduct?.prices;
                    firstAttributeActiveIds.value = productData.value.firstVariationProduct?.term_ids
                    variableDataCustomise.value = {
                        productAttributes: productData.value?.productAttributes
                    }
                   if (Object.keys(variableDataCustomise.value.productAttributes).length === 0) {
                    isButtonActive.value = false;
                    // object is empty
                    }

                    shortTermData.value = productData.value.price.short_term_data ;


                    materialPriceData.value = productData.value?.materialPriceData;
                    materialMultiplierData.value = productData.value?.materialMultiplierData;
                    const currentPriceData = productData?.value.lowestVariationData;
                    const termIds = productData?.value.firstVariationProduct.term_ids;
                    const toupOption = productData?.value?.customiseTopupOption;


                const priceLowest = calculatorPriceCustomise2(
                    currentPriceData,
                    termIds,
                    toupOption,
                    materialPriceData.value,
                    materialMultiplierData.value
                );
                saleDate.value = {
                    short_term_dates: {
                        '_date_from': productData.value.firstVariationProduct?.prices?.short_term_dates?._date_from,
                        '_date_to': productData.value.firstVariationProduct?.prices?.short_term_dates?._date_to
                    },
                    sale_price_dates: {
                        '_date_from': productData.value.firstVariationProduct?.prices?.sale_price_dates?._date_from,
                        '_date_to': productData.value.firstVariationProduct?.prices?.sale_price_dates?._date_to
                    }
                }
                priceDataCustomise.value = {
                    regular_price: priceLowest?.regular_price || '',
                    sale_price: priceLowest?.sale_price || '',
                    short_term_price: priceLowest?.short_term_price || '',
                    //short_term_data: shortTermData.value
                    short_term_dates: {
                        '_date_from': productData.value.firstVariationProduct?.prices?.short_term_dates?._date_from,
                        '_date_to': productData.value.firstVariationProduct?.prices?.short_term_dates?._date_to
                    },
                    sale_price_dates: {
                        '_date_from': productData.value.firstVariationProduct?.prices?.sale_price_dates?._date_from,
                        '_date_to': productData.value.firstVariationProduct?.prices?.sale_price_dates?._date_to
                    }

                };

                console.log('-- 111',priceDataCustomise.value);

                priceDataCustomise.value = getPriceDataCustomise(priceDataCustomise.value);

                console.log('-- 22222',priceDataCustomise.value);

                }
                productTitle.value = productData.value.post_title;
                passwordProtected.value = productData.value.passwordProtected;
                if (postStatus === 'private' && !passwordProtected.value){
                    productTitle.value = `Private:${productData.value.post_title}`;
                }else if(passwordProtected.value){
                    productTitle.value = `Protected:${productData.value.post_title}`;
                }
                _productID.value =productData.value.ID;
                breadCrumb.value = productData.value.breadcrumb;
                sku.value = isCustomise.value ? productData.value.firstVariationProduct?.sku : productData.value.sku;
                const firstSku = sku.value?.meta_value;
                initialSku.value = firstSku;
                uspSection.value = productData.value.uspData;
                if(productData.value.mediaFeed.length > 0){
                    mediaFeed.value = productData.value.mediaFeed[0];
                }
                premieumData.value = productData.value.premiumData;
                data_faq.value = productData.value.faq;
                getTheLook.value = productData.value.getTheLook;
                productGallery.value = productData.value.gallery;
                productDescription.value = productData.value.product_description;
                priceData.value = productData.value.price;
                paymentPlanData.value = productData.value.paymentPlanData || {};

                // if (isCustomise.value) {
                //     priceData.value = productData.value.firstVariationProduct?.prices;
                // }

                priceTeaser.value = productData.value.priceTeaser;
                const firstImageItem = productGallery.value.find(item => item.type === "image");
                initialImage.value = firstImageItem?.zoomsrc
                thumbnailStickyBar.value = firstImageItem ? firstImageItem.thumbnail : null,
                productTag.value = productData.value.productTag || [];
                if (isCustomise.value && !productTag.value.includes('Customisable')) {
                    productTag.value.unshift('Customisable');
                }
                const isRequestPrice = productData.value.isRequestPrice;
                productType.value = productData.value.productType;
                reviewData.value = {
                    'id' :  productData.value.ID,
                    'name' : productData.value.post_title,
                    'url': productData.value.post_name,
                    'image': firstImageItem ? firstImageItem.thumbnail : null,
                    'description':  productData.value.post_content,
                    'sku': sku.value ? sku.value.meta_value : '',
                }
                gwpEligible.value = productData.value.gwpEligible;
                // customise shipping date
                const estimatedShipping = productData.value.PostMeta.find(
                meta => meta.meta_key === 'cusomise_shipping_date'
                )?.meta_value;

                shippingDate.value = productData.value.shippingDate;
                dateDelivery.value = productData.value.shippingDateDelivery;
                dateCollection.value = productData.value.shippingDateCollection;

                if (isCustomise.value && estimatedShipping) {

                    shippingDate.value.preOrderDay = estimatedShipping;
                    shippingDate.value.preOrderType = 'set_day';
                }

                // end // customise shipping date

                const isFreeBracelet = productData.value.isFreeBracelet;
                if (isFreeBracelet) {
                    freeBraceletData.value = {
                        isFreeBracelet: isFreeBracelet,
                        freeBracelet: productData.value.freeBracelets,
                        defaultBracelet: productData.value.defaultSelectionBracelet,
                        freeBraceletsStock: productData.value.freeBraceletsStock,
                    };
                } else {
                    freeBraceletData.value = {
                        isFreeBracelet: false,
                        freeBracelet: [],
                        defaultBracelet: '',
                        freeBraceletsStock: [],
                    };
                }

                const isChainOption = productData.value.isChainOption;
                if (isChainOption) {
                    chainOptionData.value = {
                        isChainOption: isChainOption,
                        chainProduct: productData.value.chainProduct,
                        titleChainOption: productData.value.titleChainOption
                    };
                } else {
                    chainOptionData.value = {
                        isChainOption: false,
                        chainProduct: [],
                        titleChainOption: ''
                    };
                }

                const isFreeChain = productData.value?.isChainFree || null;
                if (isFreeChain) {
                    freeChainOptionData.value = {
                        isChainOption: isFreeChain,
                        chainProduct: productData.value.freeChainProduct,
                        titleChainOption: 'Complimentary chain'
                    };

                } else {
                    freeChainOptionData.value = {
                        isChainOption: false,
                        chainProduct: [],
                        titleChainOption: ''
                    };
                }

                const isLabourProduct = productData.value.isLabourProduct;
                if (isLabourProduct) {
                    labourData.value = {
                        isLabourProduct: isLabourProduct,
                        goldWeightData: productData.value.goldWeightData,
                    };
                } else {
                    labourData.value = {
                        isLabourProduct: false,
                        goldWeightData: [],
                    };
                }

                actButton.value = {
                    isRequestPrice : productData.value.isRequestPrice,
                    isEnquire : productData.value.isEnquire,
                    linkEnquire: productData.value.linkEnquire,
                    stockStatus: productData.value.stockStatus
                }

                variableData.value = {
                    productAttributes: productData.value.productAttributes,
                    availableVariations: productData.value.availableVariations,
                    variations: productData.value.variations,
                }

                const isEngraving = productData.value.isEngraving;
                const relationshipsTerm = productData.value.TermRelationship as TermRelationship[];
                

                const isEngravingCategory = relationshipsTerm.some(
                relationship =>
                    relationship.termTaxonomy.taxonomy === 'product-advanced' &&
                    relationship.termTaxonomy.term.slug === 'design-and-engraving'
                );
                if (isEngraving) {
                    engravingData.value = {
                        isEngraving: isEngraving,
                        engravingDataProduct: productData.value.engravingData,
                    };
                } else {
                    engravingData.value = {
                        isEngraving: false,
                        engravingDataProduct: [],
                    };
                    if (isEngravingCategory && productType.value !== 'yith_bundle') {
                        isButtonActive.value = false;
                        engravingDesignStatus.value = 'outofstock';
                    }
                }

                const isPre0rderProduct = productData.value.isPreOder
                if(isPre0rderProduct){
                    isPre0rder.value = isPre0rderProduct
                }

                // const productType = productData.value.productType
                if (productType.value === 'yith_bundle') {
                    bundleData.value = {
                        isBundle: true,
                        bundleDataProduct: productData.value.bundleProduct,
                    };
                } else {
                    bundleData.value = {
                        isBundle: false,
                        bundleDataProduct: [],
                    };
                }

                if (!passwordProtected.value || isPasswordSuccess.value){
                    await getProductMasterTemplate (productData.value.ID);
                    await getRelatedProducts(productData.value.ID);
                    // await getRecommendationProducts(productData.value.ID);
                    // await getReviewProducts(productData.value.ID);
                    updateRecentlyViewed(_productID.value);
                }

                //schema

                 

                const TermRelationship = productData.value.TermRelationship;

                // Check for Pixiu Bracelets - trim and normalize the comparison
                const pixiuItem = TermRelationship?.find(item => {
                    const name = item.termTaxonomy?.term?.name?.trim() ?? '';
                    return name === 'Pixiu Bracelets';
                });
                isPixiuBracelet.value = !!pixiuItem;

                const material = TermRelationship.find(item => item.termTaxonomy.taxonomy === "material")?.termTaxonomy.term.name;
                const color = TermRelationship.find(item => item.termTaxonomy.taxonomy === "product_gold-type")?.termTaxonomy.term.name;
                const availableVariations = productData.value.availableVariations;
                interface ReviewSchema {
                    "@type": string;
                    author: {
                        "@type": string;
                        name: string;
                    };
                    reviewBody: string;
                    description: string;
                    datePublished: string;
                    url: string;
                    publisher: {
                        "@type": string;
                        name: string;
                    };
                }
                const reviews = ref<ReviewSchema[]>([]);

                let offers = [];
                const YEAR_IN_SECONDS = 365 * 24 * 60 * 60;
                let priceValidUntil = new Date(Date.now() + YEAR_IN_SECONDS * 1000).toISOString().split('T')[0];
                priceValidUntil = priceValidUntil.replace(/-\d{2}-\d{2}$/, '-12-31');
                const stockStatus = productData.value.stockStatus;
                const shippingDetail = [
                              {
                                "@type": "OfferShippingDetails",
                                "shippingDestination": {
                                  "@type": "DefinedRegion",
                                  "addressCountry": "MY"
                                },
                                "shippingRate": {
                                  "@type": "MonetaryAmount",
                                  "currency": "MYR",
                                  "minValue": 0,
                                  "maxValue": 15
                                },
                                "deliveryTime": {
                                  "@type": "ShippingDeliveryTime",
                                  "transitTime": {
                                    "@type": "QuantitativeValue",
                                    "minValue": 5,
                                    "maxValue": 12,
                                    "unitCode": "DAY"
                                  }
                                }
                              }
                            ];

                if (productData.value.productType === 'variable') {
                    const prices = availableVariations.map((variation: any) => variation.variationPrice.price);
                    const lowest = Math.min(...prices);
                    const highest = Math.max(...prices);
                    const stockStatus = productData.value.PostMeta.find(meta => meta.meta_key === '_stock_status')?.meta_value;


                    if( lowest === highest ) {
                        offers = [{
                            "@type": "Offer",
                            price: convertPriceDecimal(lowest),
                            priceValidUntil: priceValidUntil,
                            availability: stockStatus === "instock" ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
                            "shippingDetails": shippingDetail,
                            "hasMerchantReturnPolicy": {
                              "@id": "https://www.skjewellery.com.my/faq/return-and-exchange/#policy"
                            },
                            url: `${baseUrl}product/${productData.value.post_name}`,
                            itemCondition: "https://schema.org/NewCondition",
                            priceSpecification: {
                                "@type": "UnitPriceSpecification",
                                price: convertPriceDecimal(productData.value.price.price),
                                priceCurrency: "MYR",
                                valueAddedTaxIncluded: "http://schema.org/False",
                                validThrough: priceValidUntil
                            }
                        }];
                    }else {
                        offers = [{
                            "@type": "AggregateOffer",
                            lowPrice: convertPriceDecimal(lowest),
                            highPrice: convertPriceDecimal(highest),
                            offerCount: Object.keys(availableVariations).length,
                            priceValidUntil: priceValidUntil,
                            availability: stockStatus === "instock" ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
                            "shippingDetails": shippingDetail,
                            "hasMerchantReturnPolicy": {
                              "@id": "https://www.skjewellery.com.my/faq/return-and-exchange/#policy"
                            },
                            url: `${baseUrl}product/${productData.value.post_name}/`,
                            itemCondition: "https://schema.org/NewCondition",
                            priceCurrency: "MYR",
                            seller: {
                                "@type": "Organization",
                                "name": "SK Jewellery",
                                "url": `${baseUrl}`
                            },
                        }];
                    }
                } else {
                    offers = [{
                        "@type": "Offer",
                        priceValidUntil: priceValidUntil,
                        availability: stockStatus === "instock" ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
                        "shippingDetails": shippingDetail,
                        "hasMerchantReturnPolicy": {
                          "@id": "https://www.skjewellery.com.my/faq/return-and-exchange/#policy"
                        },
                        url: `${baseUrl}product/${productData.value.post_name}`,
                        itemCondition: "https://schema.org/NewCondition",
                        priceSpecification: {
                            "@type": "UnitPriceSpecification",
                            price: convertPriceDecimal(productData.value.price.price),
                            priceCurrency: "MYR",
                            valueAddedTaxIncluded: "http://schema.org/False",
                            validThrough: priceValidUntil
                        },
                        seller: {
                            "@type": "Organization",
                            "name": "SK Jewellery",
                            "url": `${baseUrl}`
                        },
                    }];
                }


                 // emm schema
                    const categorySchema = [
                    'Body Jewelry',
                    'Bracelets',
                    'Brooches & Lapel Pins',
                    'Charms & Pendants',
                    'Earrings',
                    'Jewelry Sets',
                    'Necklaces',
                    'Rings'
                    ];

                    const categorySchemaPush = buildCategorySchemaPush(
                        TermRelationship,
                        categorySchema
                        )
                    // if (Array.isArray(categorySchemaPush) && categorySchemaPush.length > 0) {
                    //     schema.value.category = categorySchemaPush.join(',')
                    //     }

                    console.log('--- material:', material);
                schema.value = {
                    "@context": "https://schema.org",
                    "@type": "Product",
                    "name": productData.value.post_title,
                    "url": `${baseUrl}product/${productData.value.post_name}/`,
                    "image": `${baseUrl}api/wp-content/uploads/${initialImage.value}`,
                    "description": productData.value.post_content.replace(/<\/?[^>]+(>|$)/g, '').replace(/&nbsp;/g, '').trim(),
                    "sku": sku.value?.meta_value,
                     ...(color && { "color": color }),
                        ...(material && { "material": material }),
                    "category": categorySchemaPush.join(','),
                     
                    "offers": offers,

                    "brand": "SK Jewellery",
                };

                if( Object.keys(aggregateRatingValue.value).length > 0 ) {
                    schema.value.aggregateRating = aggregateRatingValue.value;
                }

                if (reviewDatas.value.length > 0){
                    schema.value.review = reviewDatas.value;
                }
                useHead({
                    script: [
                        {
                            type: 'application/ld+json',
                            children: JSON.stringify(schema.value)
                        }
                    ]
                });
                // Breadcrumb List Schema
                breadcrumbSchema.value = {
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                }
                let breadCrumbItems = [
                    {
                        "@type": "ListItem",
                        "position": 1,
                        "name": "Home",
                        "item": baseUrl,
                    }
                ];
                if (breadCrumb.value.parentCategory){
                    breadCrumbItems.push({
                        "@type": "ListItem",
                        "position": 2,
                        "name": htmlSpecialcharsDecode(breadCrumb.value.parentCategory.name),
                        "item": `${baseUrl}product-category/${breadCrumb.value.parentCategory.slug}`,
                    })
                }
                if (breadCrumb.value.childCategory){
                    breadCrumbItems.push({
                        "@type": "ListItem",
                        "position": 3,
                        "name": htmlSpecialcharsDecode(breadCrumb.value.childCategory.name),
                        "item": `${baseUrl}product-category/${breadCrumb.value.childCategory.slug}`
                    });
                    breadCrumbItems.push({
                        "@type": "ListItem",
                        "position": 4,
                        "name": htmlSpecialcharsDecode(productTitle.value),
                        "item": `${baseUrl}${route.path.startsWith('/') ? route.path.slice(1) : route.path}`,
                    })
                }else{
                    breadCrumbItems.push({
                        "@type": "ListItem",
                        "position": 3,
                        "name": htmlSpecialcharsDecode(productTitle.value),
                        "item": `${baseUrl}${route.path.startsWith('/') ? route.path.slice(1) : route.path}`,
                    })
                }
                breadcrumbSchema.value.itemListElement = breadCrumbItems;
                useHead({
                    script: [
                        {
                            type: 'application/ld+json',
                            children: JSON.stringify(breadcrumbSchema.value)
                        }
                    ]
                });

                // #320659 -  "@type": "Organization",

               const organizationSchema = {
                  "@context": "https://schema.org",
                  "@type": "Organization",
                  "@id": "https://www.skjewellery.com.my/#org",
                  "name": "SK Jewellery Malaysia",
                  "url": "https://www.skjewellery.com.my/",
                  "hasMerchantReturnPolicy": {
                    "@type": "MerchantReturnPolicy",
                    "@id": "https://www.skjewellery.com.my/faq/return-and-exchange/#policy",
                    "applicableCountry": "MY",
                    "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
                    "merchantReturnDays": 7,
                    "refundType": "https://schema.org/ExchangeRefund",
                    "merchantReturnLink": "https://www.skjewellery.com.my/faq/return-and-exchange/"
                  }
                }

                  useHead({
                    script: [
                        {
                            type: 'application/ld+json',
                            children: JSON.stringify(organizationSchema)
                        }
                    ]
                });

                // end schema
                // GTM
                let gtmItemPrice: string = productData.value.price.price.toString();
                let gtmItemID: number = (Number(productData.value.ID));
                let gtmItemSKU: string = (productData.value.sku?.meta_value ? productData.value.sku.meta_value : '');
                let stocklevel = productData.value.PostMeta.find(meta => meta.meta_key === '_stock')?.meta_value;
                let gtmStockLevel: number | null = (stocklevel ? Number(stocklevel) : null);
                let gtmStockStatus: string = (productData.value.stockStatus);
                let gtmInternalId: number | null = null;
                let gtmVariant: string | null = null;

                const gtmProductCategories = TermRelationship.filter(relationship => relationship.termTaxonomy.taxonomy === 'product_cat').map(relationship =>{
                    const name = relationship.termTaxonomy.term.name;
                    return name;
                });
                if (productData.value.productType === 'variable' && availableVariations.length > 0) {
                    const { minVariationPrice, minIndex } = availableVariations.reduce((acc, variation, index) => {
                        const variationPrice = parseFloat(variation.product.PostMeta.find(meta => (meta?.meta_key === '_price'))?.meta_value || '0');

                        if (variationPrice < acc.minVariationPrice) {
                            return { minVariationPrice: variationPrice, minIndex: index };
                        }
                        return acc;
                    }, { minVariationPrice: Infinity, minIndex: -1 });

                    const firstAvailableVariation = (minIndex !== -1) ? availableVariations[minIndex] : availableVariations[0];
                    if (firstAvailableVariation) {
                        firstVariation.value = firstAvailableVariation;
                        const stock22 = firstAvailableVariation.product.PostMeta.find(meta => meta.meta_key === '_stock')?.meta_value;
                        firstVariation.value.stock = stock22;

                        gtmInternalId = gtmItemID;
                        gtmItemPrice = firstAvailableVariation.variationPrice.price.toString();
                        gtmItemID = Number(firstAvailableVariation.id);
                        gtmItemSKU = firstAvailableVariation.sku;
                        gtmStockStatus = firstAvailableVariation.product.PostMeta.find(meta => meta.meta_key === '_stock_status')?.meta_value;
                        gtmItemSKU = firstAvailableVariation.product.PostMeta.find(meta => meta.meta_key === '_sku')?.meta_value;
                        if (Object.values(firstAvailableVariation.attrs).length > 0) {
                            const gtmAttributes = Object.values(firstAvailableVariation.attrs);
                            gtmVariant = gtmAttributes.join(", ");
                        }
                    }
                }

                setDataLayer(productData.value.ID);
                // let gtmItem = {
                //     item_name: productData.value.post_title,
                //     item_id: gtmItemID,
                //     price: gtmItemPrice,
                //     item_brand: '',
                //     sku: gtmItemSKU,
                //     google_business_vertical: "retail",
                //     stockstatus: gtmStockStatus,
                //     stocklevel: gtmStockLevel,
                //     id: gtmItemID
                // }

                // if (gtmInternalId){
                //     gtmItem.internal_id = gtmInternalId;
                // }
                // if (gtmVariant){
                //     gtmItem.variant = gtmVariant;
                // }
                // if (gtmProductCategories.length > 0){
                //     gtmProductCategories.forEach((category: string, index: number) => {
                //         gtmItem[`item_category${index === 0 ? '' : index + 1}`] = category;
                //     });
                // }
                // gtmProps.value = gtmItem;
                // singleViewItemEvent(gtmItem);
                // Tracking Lexer
                let lexerEventData: {eventName: string, eventValue: string}[] = [];
                lexerTrackingData.value.push({eventName: 'products_viewed', eventValue: htmlSpecialcharsDecode(productData.value.post_title)})
                lexerEventData.push({eventName: 'products_viewed', eventValue: htmlSpecialcharsDecode(productData.value.post_title)});
                if (gtmProductCategories.length > 0){
                    gtmProductCategories.forEach((category: string, index: number) => {
                        lexerEventData.push({eventName: 'categories_viewed', eventValue: htmlSpecialcharsDecode(category)})
                        lexerTrackingData.value.push({eventName: 'categories_viewed', eventValue: htmlSpecialcharsDecode(category)})
                    });
                }


            }else{

                const router = useRouter();
                router.push(`${country}/404/`);
                return;
            }

        } catch (e) {
            console.error('getProductData Error:', e);
        }
    };

    const dataInsiderRelated = ref({} as {
        campaignId: number;
        variationId: number;
        products: IProductItem[];
    });
    const dataInsiderRecommend = ref({} as {
        campaignId: number;
        variationId: number;
        products: IProductItem[];
    });

    const setupInsiderEventListener = () => {
        // Function to setup the actual listener
        const setupListener = () => {
            if (typeof window !== 'undefined' && (window as any).Insider) {
                (window as any).Insider.eventManager.on('ins-sr:only-api-campaign:load', function (event: any, data: any) {
                    // Only store data if campaignId=209 and variationId=421
                    // console.log('data_insider_single:', data);
                    if(data && data.campaignId === 68 && data.variationId === 126){
                        // dataInsiderRelated.value = {
                        //     campaignId: data.campaignId,
                        //     variationId: data.variationId,
                        //     products: data.products || []
                        // };
                        const products = Array.isArray(data.products) && data.products.length > 0 ? data.products : [];
                        if (products.length > 0) {
                            // console.log('ok Related');
                            dataInsiderRelated.value = {
                                campaignId: data.campaignId,
                                variationId: data.variationId,
                                products: products
                            };
                            isCheckResponInsider.value = true;
                        }
                    }
                    if (data && data.campaignId === 64 && data.variationId === 118) {
                        // dataInsiderRecommend.value = {
                        //     campaignId: data.campaignId,
                        //     variationId: data.variationId,
                        //     products: data.products || []
                        // };
                        const products = Array.isArray(data.products) && data.products.length > 0 ? data.products : [];
                        if (products.length > 0) {
                            // console.log('ok Recommend');
                            dataInsiderRecommend.value = {
                                campaignId: data.campaignId,
                                variationId: data.variationId,
                                products: products
                            };
                            isCheckResponInsider.value = true;
                        }

                    } 
                    
                });
            } else {
                console.warn('⚠️ Insider SDK not found yet');
            }
        };

        // Check if Insider SDK is already loaded
        if (typeof window !== 'undefined' && (window as any).Insider) {
            setupListener();
        } else {
            const listenInsiderInit = () => {
                document.addEventListener('insider:api-initialized', function onInsiderInit() {
                    setupListener();
                    // Remove listener after setup
                    document.removeEventListener('insider:api-initialized', onInsiderInit);
                });
            };

            listenInsiderInit();
        }
    };

    const isPasswordSuccess = ref<boolean>(false);
    const isCheckResponInsider = ref(false);


    const handlePasswordProtect = (success: boolean) => {
        isPasswordSuccess.value = success;
    };

    const apiKey = "67a493e9-b709-4443-8008-b3538dde4d34";
	const apiSecret = "3219826669e0d0d7f97aff5b0e352d3795d4b4b0c61d1d3e8d586aba6a55c1ac";
    const getReviewProducts = async (productId: Number) => {
        try {
            const authorizationHeader = `Basic ${btoa(`${apiKey}:${apiSecret}`)}`;
            const { data: response } = await useAsyncData(
                'data-2222',
                async () => $ajax.get(`https://stamped.io/api/v2/210582/dashboard/reviews?productId=${productId}`,{
                            headers: {
                                Authorization: authorizationHeader,
                            }
                        }),
                { immediate: true }
                );
            // const response = await $ajax.get(`https://stamped.io/api/v2/210582/dashboard/reviews?productId=${productId}`, {
            //     headers: {
            //         Authorization: authorizationHeader,
            //     },
            // });
        } catch (error) {
            throw error;
        }
    }

    interface RecentlyViewedArray {
        [index: number]: string;
    }
    const recentlyViewedCookie = useCookie('api_woocommerce_recently_viewed')
    const updateRecentlyViewed = (productId: string): void => {
        let recentlyViewed: string[];

        try {
            recentlyViewed = recentlyViewedCookie.value ? recentlyViewedCookie.value : []
            // Ensure recentlyViewed is an array
            if (!Array.isArray(recentlyViewed)) {
                recentlyViewed = []
            }
        } catch (error) {
            // If there's an error parsing, start with an empty array
            recentlyViewed = []
        }
        recentlyViewed = recentlyViewed.filter(id => id !== productId)

        // Add the new productId to the end of the array
        recentlyViewed.unshift(productId)

        // If there are more than 15 items, remove the oldest one
        if (recentlyViewed.length > 5) {
            recentlyViewed.pop()
        }

        // Update the cookie with the new array
        recentlyViewedCookie.value = JSON.stringify(recentlyViewed)
    }
    const itemInformation = ref();
    const getProductMasterTemplate = async (productId: Number) => {
        try {
            const response: ResponseAPI = await $ajax.get('wp-json/skj/v1/product-master-template/'+productId, {
                headers: {
                    Authorization: `Bearer ${userStore.csrf}`,
                    'X-API-Server': userStore.csrf_server
                },
            });
            // const response: ResponseAPI = await $ajax.get('wp-json/skj/v1/product-master-template/'+productId);
            if (response.success && response.data && response.data !== null) {
                itemInformation.value = response.data;
            }
        } catch (error) {
            console.warn(error);
        }
    }
    const recommendationProducts = ref();
    const recommendationProductsSuccess = ref(false);
    const getRecommendationProducts = async (productId: Number) => {
        try {
            const response: ResponseAPI = await $ajax.get('wp-json/skj/v1/get-recommendation-products/'+productId, {
                headers: {
                    Authorization: `Bearer ${userStore.csrf}`,
                    'X-API-Server': userStore.csrf_server
                },
            });
            // const response: ResponseAPI = await $ajax.get('wp-json/skj/v1/get-recommendation-products/'+productId);
            if (response.success && response.data && response.data !== null && response.data.products && response.data.products.length > 0) {
                recommendationProducts.value = response.data;
                singleViewItemListEventTracking(response.data.products, "Recommendation Products");
                recommendationProductsSuccess.value = true;
            }
        } catch (error) {
            console.warn(error);
        }
    }

    const relatedProducts = ref();
    const getRelatedProducts = async (productId: Number) => {
        try {
            const response: ResponseAPI = await $ajax.get('wp-json/skj/v1/get-related-products/'+productId, {
                headers: {
                    Authorization: `Bearer ${userStore.csrf}`,
                    'X-API-Server': userStore.csrf_server
                },
            });
            // const response: ResponseAPI = await $ajax.get('wp-json/skj/v1/get-related-products/'+productId);
            if (response.success && response.data && response.data !== null && response.data.products && response.data.products.length > 0) {
                relatedProducts.value = response.data;
                singleViewItemListEventTracking(response.data.products, "Related Products");
            }
        } catch (error) {
            console.warn(error);
        }
    }
    const updatePriceInfo = (updatedPriceInfo: any) => {

        priceData.value = {
            ...priceData.value,
            ...updatedPriceInfo
        };


    };
        const updatePriceInfoCustomise = (updatePriceInfoCustomise: any) => {
        if (isCustomise.value) {

            priceDataCustomise.value =  {
                ...updatePriceInfoCustomise
            };

            console.log('--- price customise; ',getPriceDataCustomise(priceDataCustomise.value))
           priceDataCustomise.value = getPriceDataCustomise(priceDataCustomise.value);
        }
    };
    import type { IProductItem } from "~/types/productItem";
    interface IProductResponse{
        success: boolean;
        data: IProductItem[];
        url?: string;
    }
    const recentlyProducts = ref<IProductItem[]>();
    const getRecentlyViewedProducts = async () => {
        try {
            if (recentlyViewedCookie.value){
                const { data: recentlyData } = await useAsyncData<IProductResponse>(
                    'recentlyData',
                    async () => {
                        return $ajax.get(`${runtimeConfig.public.API_URL}productids/${recentlyViewedCookie.value}`, {
                            headers: {
                            'X-API-Key': userStore.csrf,
                            'X-API-Server': userStore.csrf_server
                            }
                        });
                        // return $ajax.get(`http://localhost:3005/data/productids/${recentlyViewedCookie.value}`);
                    }
                );
                if (recentlyData && recentlyData.value && recentlyData.value.success === true) {
                    console.log('---- recentlyData.value.data',recentlyData.value.data)
                    recentlyProducts.value = recentlyData.value.data;
                }
            }
        } catch (e) {
            console.error("Error fetching recently viewed products:", e);
        }
    };

    // getProductData() is called by watch(() => route.params.slug)

    const option_faqs = ref({
        "type" : 1,
        "defaultActiveIndex" : 0,
        "style": {
            item: {
                background: '',
                hoverBackground: '',
                textColor: '#212529',
                hoverColor: '',
                fontSize: '16px'
            },
            icon: {
                background: '#000',
            },
            content: {
                background: 'rgba(157, 157, 157, 0.1)',
                textColor: '#212529',
                fontSize: '14px'
            }
        },
    })

    //active button act //
    const isButtonActive = ref(true);

    const handleSelectionUpdate = (isActive: boolean) => {
        isButtonActive.value = isActive;
    };

    //end active button act //

    //preoder
    const isPre0rder = ref(false);
    const handlePreOderUpdate = (isActive: boolean) => {
        isPre0rder.value = isActive;
    };
    //end preorder
    const updateSku = (newSku: string) => {
        if(!newSku){
            if (sku.value){
                sku.value.meta_value = initialSku.value;
            }
        }else{
            if (sku.value){
                sku.value.meta_value = newSku
            }
        }
    }
    // getRecentlyViewedProducts() is called by watch(() => route.params.slug)

const galleryItems = ref<any[]>([]);
// const updateGalleryImage = (newImage: any) => {
//    // console.log('---- newImage',newImage);
//    // console.log('--- productGallery.value',productGallery.value)
//     if (!newImage) {
//         //console.log('old img')
//         productGallery.value[0].thumbnail = initialImage.value;
//         productGallery.value[0].woocommerce_single = initialImage.value;
//         productGallery.value[0].zoomsrc = initialImage.value;

//         const galleryItems = Object.values(
//           initialImage.value?.gallery_items || {}
//         ) as GalleryItem[];

//         productGalleryCustomise.value = [
//             ...galleryItems,
//             ...productGalleryProduct.value
//         ];
//         //console.log('old img: ',productGalleryCustomise.value)

//     } else if (productGallery.value.length > 0) {
//     //console.log('-333333');

//         if (isCustomise.value) {
//        // console.log('- 44444');

//             galleryItems.value = newImage.gallery_items;

//             productGalleryCustomise.value = [
//                 ...galleryItems.value,
//                 ...productGalleryProduct.value
//             ];

//             //console.log('galleryItems:', galleryItems.value);
//             //console.log('productGalleryCustomise:', productGalleryCustomise.value);
//             // console.log('- 44444 bbbb',productGalleryCustomise.value);

//             // galleryItems.value = newImage.gallery_items;
//             // console.log('new img: ',galleryItems.value)

//         } else {
//             productGallery.value[0].thumbnail = newImage;
//             productGallery.value[0].woocommerce_single = newImage;
//             productGallery.value[0].zoomsrc = newImage;
//         }
//     }
// };
const updateGalleryImage = (newImage: any) => {
   // console.log('--- productGallery newImage: ',newImage,productGallery.value)
    const imageIndex = productGallery.value.findIndex(item => item.type === "image");

    if (!newImage) {
        console.log('-- 11111')
        if (imageIndex !== -1 && productGallery.value[imageIndex]) {
            productGallery.value[imageIndex].thumbnail = initialImage.value;
            productGallery.value[imageIndex].woocommerce_single = initialImage.value;
            productGallery.value[imageIndex].zoomsrc = initialImage.value;
        }

        // Update merged gallery
        productGalleryCustomise.value = [
            ...Object.values(initialImage.value?.gallery_items || {}),
            ...productGalleryProduct.value
        ];

    } else  {

        if (isCustomise.value) {
        //console.log('--- 22222')
            // Update merged gallery with new image
            productGalleryCustomise.value = [
                ...Object.values(newImage.gallery_items || {}),
                ...productGalleryProduct.value
            ];

            galleryItems.value = newImage.gallery_items;

        } else if (imageIndex !== -1 && productGallery.value[imageIndex]) {
            productGallery.value[imageIndex].thumbnail = newImage;
            productGallery.value[imageIndex].woocommerce_single = newImage;
            productGallery.value[imageIndex].zoomsrc = newImage;
        }
    }
}
const updateGalleryImage_old = (newImage: any) => {
    if (!newImage) {

        productGallery.value[0].thumbnail = initialImage.value;
        productGallery.value[0].woocommerce_single = initialImage.value;
        productGallery.value[0].zoomsrc = initialImage.value;

        // Update merged gallery
        productGalleryCustomise.value = [
            ...Object.values(initialImage.value?.gallery_items || {}),
            ...productGalleryProduct.value
        ];

    } else if (productGallery.value.length > 0) {

        if (isCustomise.value) {
            // Update merged gallery with new image
            productGalleryCustomise.value = [
                ...Object.values(newImage.gallery_items || {}),
                ...productGalleryProduct.value
            ];

            galleryItems.value = newImage.gallery_items ;

        }else {
             productGallery.value[0].thumbnail = newImage;
             productGallery.value[0].woocommerce_single = newImage;
             productGallery.value[0].zoomsrc = newImage;
        }
    }
}

const updateThumbnailImage =  (newImage: any) => {
    if (!newImage) {

    } else if (productGallery.value.length > 0) {

        if (isCustomise.value)
        thumbnailStickyBarCustomise.value = newImage;
    }

}

const livesupportPosition = () => {
  const liveSupportWidget = document.querySelector('#oa-live-support-widget .oa-live-support');
  const isProduct = document.querySelector('#product');
  if (liveSupportWidget) {
      if(isProduct) {
          liveSupportWidget.classList.add('spd');
      }else{
          liveSupportWidget.classList.remove('spd');
      }
  }
}

const firstLoad = ref(false);

// _productID

const fetchVoucherProduct = async () => {
    if(_productID.value){
        try {
            const response = await $ajax({
                method: 'POST',
                url: '/wp-json/skj/v1/get_vouchers/',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userStore.csrf}`,
                    'X-API-Server': userStore.csrf_server
                },
                data: JSON.stringify({
                    id: _productID.value,
                }),
            });
        } catch (error) {
          console.error('Fetch failed:', error);
        }
    }
}


watch(asyncSingleProduct, async (newVal) => {
    if (newVal) {
        await getProductData();
    }
}, { immediate: true });

watch(() => route.params.slug, async (newSlug, oldSlug) => {
    if (newSlug) {
        // fetchVoucherProduct();
        await getRecentlyViewedProducts();
        if (oldSlug && newSlug !== oldSlug) {
            if (typeof window !== 'undefined') {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    }
}, { immediate: true });

watch(productData, (newVal, oldVal) => {
  if (newVal) {
    if (typeof window !== 'undefined' && window.dataLayer) {
      if (productData.value && productData.value.productType != 'variable') {
            handleVariantChange('');
        }
    }
  }
});
watch(firstVariation, (newVal, oldVal) => {
  if (newVal) {
    if (typeof window !== 'undefined' && window.dataLayer) {
        handleVariantChange('');
    }
  }
});

// insider search

const mapCookieToProduct = (
    data: InsiderClickCookie,
    rate: number,
    currency: string
): IInsiderProduct => {
    const price = data?.price || 0
    const facets = data?.dataSearch?.facets
    const position = data?.position || 1;
    const resultCount = data?.dataSearch?.resultCount || 1;

    return {
        id: String(data.productId || 'na'),
        groupCode: String(data.productId || 'na'),
        query: data?.dataSearch?.query || '',

        price,
        convertedPrice: Math.floor(price * rate),

        currency: 'MYR',
        preferredCurrency: currency,


        clickPosition: position,
        searchPosition: position,
        Position: position,
        quantity: 1,

        resultCount: resultCount,
        itemsPerPage: data?.dataSearch?.itemsPerPage || 1,
        totalPages: data?.dataSearch?.totalPages || 1,

        ...(data?.dataSearch?.sorting
            ? { sorting: data.dataSearch.sorting }
            : {}),

        ...(Array.isArray(facets) && facets.length > 0
            ? { facets }
            : {})
    }
}


type InsiderClickCookie = {
    url: string
    productId?: string | number
    price: number
    position: number
    dataSearch: any,
    facets: any,
    dateClick: string,
    SearchSessionId:string,
    CurrentPage: number
}

const COOKIE_NAME = 'insider_product_click'
const SESSION_KEY = 'insider_active_click'


const handleInsiderSearchClick = async () => {
    const cookieValue = getCookie(COOKIE_NAME)

    if (!cookieValue) {
        sessionStorage.removeItem(SESSION_KEY)
        return
    }

    let items: InsiderClickCookie[]

    try {
        items = JSON.parse(cookieValue)
        if (!Array.isArray(items)) throw new Error('Invalid cookie')
    } catch {
        removeCookie(COOKIE_NAME)
        sessionStorage.removeItem(SESSION_KEY)
        return
    }

    const normalizePath = (url = '') =>
        url.replace(/^\/+/, '').replace(/\/+$/, '')

    const currentPath = normalizePath(route.path)

    // 🔥 lấy item CUỐI CÙNG match URL
    const dataIndex = [...items]
        .map((item, index) => ({ item, index }))
        .reverse()
        .find(({ item }) => normalizePath(item.url) === currentPath)?.index

    if (dataIndex === undefined) {
        sessionStorage.removeItem(SESSION_KEY)
        return
    }

    const data = items[dataIndex]

    if (!data?.productId) {
        sessionStorage.removeItem(SESSION_KEY)
        return
    }

    // ✅ lưu item hiện tại vào sessionStorage
    data.dateClick = getSingaporeRFC3339();
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(data))

    const rate = Number(wooStore.currency.rate) || 1
    const product = mapCookieToProduct(data, rate, currency)
    const platform: 'desktop-web' | 'mobile-web' =
    window.innerWidth <= 768 ? 'mobile-web' : 'desktop-web';
    const position = data?.position || 1;
    const resultCount = data?.dataSearch?.resultCount || 1;
    const currentpage = Math.ceil(position / 40);
    const payload = trackInsiderSearchEvent({
        referrer: data.dataSearch?.referrer || document.referrer || '',
        source: 'search-listing',
        platform: platform,
        eventType: 'product-click',
        integrationType: 'web',
        SearchSessionId: data?.dataSearch?.searchSessionId || '',
        CurrentPage: currentpage,
        product
    })

    if (!payload) return

    

    const uuid = userStore.dataInsiderSdk?.uuid || '';
    const uid = getUUidInsiderSearch(uuid) || 'guest';
    payload.userId = uid

   // console.log('✅ Insider payload:', payload)
    sendInsiderEvent(payload)

    // 🔥 chỉ remove item đã dùng, giữ lại item khác
    const remaining = items.filter((_, idx) => idx !== dataIndex)

    if (remaining.length > 0) {
        setCookie(COOKIE_NAME, JSON.stringify(remaining), 20)
    } else {
        removeCookie(COOKIE_NAME)
    }
}

// end insider search

onMounted(() => {
     setupInsiderEventListener();
     handleInsiderSearchClick();
    useSingleMeta({
        priceAmount: priceData.value?.price,
        priceCurrency: "MYR"
    });
    const routeslug = useRoute();
    const pathSegments = routeslug.path.split('/').filter(segment => segment);
    const pageType = 'product page';
    const hierachy1 = pathSegments[0] || 'n/a';
    const hierachy2 = pathSegments[1] || 'n/a';
    const hierachy3 = 'n/a';
    pushPageTypeToDataLayer(pageType, {
        hierachy1,
        hierachy2,
        hierachy3,
    });
    setTimeout(async() => {
        const summary = document.querySelector(".summary.entry-summary");
        if (summary) {
            const summaryHeight = summary.clientHeight;
            maxHeight.value = summaryHeight;

        }
    }, 1000);
    altLazyIO();
    livesupportPosition();
    window.addEventListener('mousemove', (e) => {
        if ( firstLoad.value == false){
            lexerTracking(lexerTrackingData.value);
            firstLoad.value = true;
        }
    });
    if (window.innerWidth < 768) {
        window.addEventListener('touchstart', (e) => {
        if ( firstLoad.value == false){
            lexerTracking(lexerTrackingData.value);
            firstLoad.value = true;
        }
        });
    }
    loadExternalResources();
    waitFor('.single-product__review #tab-reviews', createSectionReview);

    // insider
    if (typeof window !== 'undefined' && window.dataLayer) {
        if (productData.value && productData.value.productType != 'variable') {
            handleVariantChange('');
        }
    }

});
function loadExternalResources(): void {
  useHead({
    style: [
      {
        children: `
          .custom_pt_review {
            display: flex;
            gap: 10px;
            align-items: center;
            top: -10px;
            position: relative;
            cursor: pointer;
          }
          .custom_pt_review .number_review:hover {
            color: #ad073d !important;
          }
          .custom_pt_review .stamped-starrating {
            line-height: 1;
          }
          .custom_pt_review .stamped-starrating i {
            line-height: 1;
            color: #ad073d !important;
          }
          .custom_pt_review .stamped-starrating i::before {
            font-size: 18px;
          }
        `
      }
    ]
  });
}

function createSectionReview(): void {
  if (document.querySelector('.custom_pt_review')) return;

  const sectionReview = document.querySelector('.single-product__review #tab-reviews');
  const headingProduct = document.querySelector('.entry-summary .heading_product');

  if (sectionReview && headingProduct) {
    const numberReview = parseInt(sectionReview.getAttribute('data-count') || '0', 10);

    if (!isNaN(numberReview) && numberReview > 0) {
      const stampedStarRating = document.querySelector('.single-product__review .stamped-starrating.stamped-summary-starrating');
      const starRatingHTML = stampedStarRating ? stampedStarRating.outerHTML : '';
      const newData = `
        <div class="custom_pt_review">
          ${starRatingHTML}
          <span class="number_review">(${numberReview} reviews)</span>
        </div>
      `;

      headingProduct.insertAdjacentHTML('afterend', newData);

      const numberReviewElement = document.querySelector('.custom_pt_review');
      if (numberReviewElement) {
        const heightBanner = document.querySelector('.site-header #alt-header-desktop #alt-header-menu-primary');
        numberReviewElement.addEventListener('click', () => {
          const reviewSection = document.getElementById('single-product__review');
          if (reviewSection && heightBanner) {
            const bannerHeight = heightBanner.clientHeight;
            let scrollDiv = reviewSection.offsetTop - bannerHeight - 20;
            if (window.innerWidth < 1020) {
              scrollDiv -= 60;
            }
            window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
          }
        });
      }
    }
  }
}

function waitFor(selector: string, callback: (element: Element) => void): void {
  const interval = setInterval(() => {
    const element = document.querySelector(selector);
    if (element) {
      clearInterval(interval);
      callback(element);
    }
  }, 100);
}


const findVariationByAttributes = (variations, targetAttributes) => {
    return variations.find(variation => {
        const attrs = variation.attrs;
        
        return Object.keys(targetAttributes).every(key => {
            const attrKey = `attribute_${key}`;
            return attrs[attrKey] === targetAttributes[key];
        });
    });
};
const handleVariantChange = (mutableSelectedOptions) => {
 // data layer
 
               let matchedVariation: any = null;
               let stockFirst = '';
               let id = productData?.value?.ID || '';
                if (id !== '') {
                let regularPrice = priceData.value.regular_price || '';
                let sale_price = priceData.value.sale_price || '';
                if (mutableSelectedOptions != '') {
                
                    const availableVariations = productData.value.availableVariations;
                    matchedVariation = findVariationByAttributes(
                        availableVariations, 
                        mutableSelectedOptions
                    );
                    id = matchedVariation.product.ID;
                } else {
                    if (firstVariation.value && Object.keys(firstVariation.value).length > 0) {
                    const firstVariationValue = firstVariation.value;

                     id = firstVariationValue.id;
                    const prices = firstVariationValue.variationPrice || {};

                     regularPrice = prices.regularPrice;
                     sale_price = prices.salePrice || prices.price;
                     stockFirst = firstVariationValue?.stock || '';
                    }
                
                    
                }

                const postMeta = (mutableSelectedOptions != '' && matchedVariation && matchedVariation.product)
                ? matchedVariation.product.PostMeta
                : productData.value.PostMeta;

                    const stockStatusMeta = postMeta.find(meta => meta.meta_key === '_stock_status');

                    const stockMeta = postMeta.find(meta => meta.meta_key === '_stock');
                    const stock = stockMeta ? (stockMeta.meta_value != null ? stockMeta.meta_value : '') : '';

               // const in_stock = matchedVariation
                const lang = route.params.lang || '';
                    let urlProduct;

                    if (lang) {
                        urlProduct = `${baseUrl}${lang}/product/${productData.value.post_name}`;
                    } else {
                        urlProduct = `${baseUrl}product/${productData.value.post_name}`;
                    }



                const TermRelationship = productData.value.TermRelationship;
                const category = TermRelationship
                .filter(item => item.termTaxonomy.taxonomy === "collection")
                .map(item => item.termTaxonomy.term.name);

                const MetalColor = TermRelationship
                .filter(item => item.termTaxonomy.taxonomy === "product_gold-type")
                .map(item => item.termTaxonomy.term.name);
                
                 regularPrice = Math.floor(Number((regularPrice * 1).toFixed(2)));
                const adjustedPriceSale = Number(sale_price) > 0 ? Math.floor(Number((sale_price * 1).toFixed(2))) : regularPrice;

                const productGallery = productData.value.gallery;
                const firstImageItem = productGallery.find((item) => item.type === "image");
                const thumbnailUrl = firstImageItem?.thumbnail || '';

                 const categoryTax = TermRelationship
                .filter(item => item.termTaxonomy.taxonomy === "product_cat")
                .map(item => item.termTaxonomy.term.slug);

                let skuParent = skuData.value?.meta_value || '';

                const hasBundle = categoryTax.some(slug => slug.includes('bundle-sets'));

                if (!hasBundle) {
                    skuParent = skuParent.replace(/\./g, '-'); 
                }

                const categoryTaxName = TermRelationship
                    .filter(item => item.termTaxonomy.taxonomy === "product_cat")
                    .map(item => item.termTaxonomy.term.name);

                    const occasion = TermRelationship
                    .filter(item => item.termTaxonomy.taxonomy === "product_occasions")
                    .map(item => item.termTaxonomy.term.name);

                    const customValue: any =  {
                    product_types: categoryTaxName
                    }
                    const occasionArray = TermRelationship
                    .filter(item => item.termTaxonomy.taxonomy === "product_occasions")
                    .map(item => item.termTaxonomy.term.name);
                    const occasionStr = occasionArray.join(", ");
                    if (occasionStr.trim() !== "") {
                        customValue.occasions = occasionArray;
                    }

                const baseDataInsiderSdk: any = {
                       "id": String(skuParent),
                     // "sku": skuParent,
                      name: productData.value.post_title,
                      taxonomy: category,
                      unit_price: regularPrice,
                      unit_sale_price: adjustedPriceSale, // if there is no sale price, regular price will be here
                      url: urlProduct,
                      product_image_url: `${baseUrl}api/wp-content/uploads/${thumbnailUrl}`,
                      custom: customValue
                    };

                  if (MetalColor && MetalColor !== '' && !(Array.isArray(MetalColor) && MetalColor.length === 0)) {
                    baseDataInsiderSdk.color = Array.isArray(MetalColor) ? MetalColor.join(', ') : String(MetalColor);
                }
                if (stock !== '' && !isNaN(Number(stock))) {
                  baseDataInsiderSdk.stock = parseInt(stock, 10);
                }

                

                  productDataInsiderSdk.value = Object.assign(baseDataInsiderSdk, []);
                  const updatedProductDataInsiderSdk = {
                    ...productDataInsiderSdk.value
                  }
                  
                  // Push datalayer
                  pushDataInsiderSdk(updatedProductDataInsiderSdk);
                  }
                }
                    const {
                    trackInsiderSdkEvent
                    } = useInsiderSdk();

                 const pushDataInsiderSdk = (data_insider:any) => {
                  if (window.dataLayer) {
                     trackInsiderSdkEvent(
                    'insider_sdk_view_item',
                    'product',
                    currency,
                    { insider_view_item_value: data_insider }
                    );
                  }
                  
                }

</script>